import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/util"

const customBadgeVariants = cva(
  "inline-flex items-center justify-center font-gilroy font-semibold",
  {
    variants: {
      variant: {
        default: "",
        outline: "border",
      },
      color: {
        default: "bg-muted text-foreground",
        green: "bg-success-foreground text-success",
        red: "bg-danger-foreground text-danger",
        amber: "bg-warning-foreground text-warning",
        purple: "bg-purple-foreground text-purple",
        blue: "bg-blue-foreground text-blue",
        rose: "bg-rose-foreground text-rose",
      },
      size: {
        default: "text-sm px-3 py-1 rounded-sm",
        sm: "text-[13px] px-2.5 py-0.5 rounded-sm",
        xs: "text-xs px-2.5 py-0.5 rounded-sm",
        lg: "text-base px-4 py-1.5 rounded-lg",
      },
    },
    compoundVariants: [
      { variant: "outline", color: "default", className: "border-border bg-muted/25 dark:bg-muted/75 text-foreground" },
      { variant: "outline", color: "green", className: "border-success/50 bg-success-foreground/25 dark:bg-success-foreground/75 text-success" },
      { variant: "outline", color: "red", className: "border-danger/50 bg-danger-foreground/25 dark:bg-danger-foreground/75 text-danger" },
      { variant: "outline", color: "amber", className: "border-warning/50 bg-warning-foreground/25 dark:bg-warning-foreground/75 text-warning" },
      { variant: "outline", color: "purple", className: "border-purple/50 bg-purple-foreground/25 dark:bg-purple-foreground/75 text-purple" },
      { variant: "outline", color: "blue", className: "border-blue/50 bg-blue-foreground/25 dark:bg-blue-foreground/75 text-blue" },
      { variant: "outline", color: "rose", className: "border-rose/50 bg-rose-foreground/25 dark:bg-rose-foreground/75 text-rose" },
    ],
    defaultVariants: {
      variant: "default",
      color: "default",
      size: "default",
    },
  }
)

function CustomBadge({
  children,
  className,
  variant,
  color,
  size,
  icon,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof customBadgeVariants> & { icon?: any }) {
  let Icon = icon || null
  const iconSize = size === "sm" ? 14 : size === "xs" ? 16 : size === "lg" ? 24 : 20
  const paddingClass = Icon ? (size === "sm" || size === "xs" ? "pl-1.5" : size === "lg" ? "pl-2.5" : "pl-2") : ""
  return (
    <div data-slot="badge" className={cn(customBadgeVariants({ variant, color, size }), paddingClass, className)} {...props} >
      {Icon && <Icon className="mr-1 shrink-0" size={iconSize} strokeWidth={2.5} />}
      {children}
    </div>
  )
}

export { CustomBadge, customBadgeVariants }
